import ParamPropMixin from './PropsMixins/ParamPropMixin';

export default {
	mixins: [ParamPropMixin],
	computed: {
		selectItems() {
			if (this.param.hasOwnProperty('options') && Array.isArray(this.param.options)) {
				return this.param.options.map(({ text: option, value, subText, disabled, required_entitlement, should_display_subtext_only }) => ({
					option,
					value,
					subText,
					disabled,
					required_entitlement,
					should_display_subtext_only,
				}));
			}
			return [];
		},
	},
};
